function moveShippinCalc(){
  if ($(window).width() < 768) {
    $('.side-cart').appendTo('.mobile-cart .ajax-cart form');
  }
}

export default moveShippinCalc();



// WEBPACK FOOTER //
// ../markup/assets/js/move-shipping-calc.js